export class SessionService {
  private static getSessionCheckUrl(): string {
    const path = '/sapps/buyonline/application/SessionCheck.action'
    return import.meta.env.DEV
      ? path
      : `${import.meta.env.VITE_BCBSNC_URL}${path}`
  }

  static hasActiveSession(): Promise<boolean> {
    return new Promise((resolve) => {
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.style.position = 'absolute'
      iframe.style.width = '0'
      iframe.style.height = '0'

      let settled = false

      const cleanup = () => {
        window.removeEventListener('message', onMessage)
        clearTimeout(timeoutId)
        if (iframe.parentNode) {
          iframe.parentNode.removeChild(iframe)
        }
      }

      const finish = (isActive: boolean) => {
        if (settled) {
          return
        }
        settled = true
        cleanup()
        resolve(isActive)
      }

      const onMessage = (event: MessageEvent) => {
        const isLoggedIn =
          typeof event.data === 'object' && event.data !== null
            ? (event.data as { isBuyonlineLoggedIn?: boolean })
                .isBuyonlineLoggedIn
            : undefined

        if (isLoggedIn === true) {
          finish(true)
        }

        if (isLoggedIn === false) {
          finish(false)
        }
      }

      const timeoutId = window.setTimeout(() => {
        finish(false)
      }, 5000)

      window.addEventListener('message', onMessage)

      iframe.onerror = () => {
        finish(false)
      }

      iframe.src = this.getSessionCheckUrl()
      document.body.appendChild(iframe)
    })
  }

  static async logout(): Promise<void> {
    const logoutPath = import.meta.env.DEV
      ? '/sapps/buyonline/application/OnlineApplicationControl_logout.action'
      : `${import.meta.env.VITE_BCBSNC_URL}/sapps/buyonline/application/OnlineApplicationControl_logout.action`

    try {
      await new Promise<void>((resolve, reject) => {
        const iframe = document.createElement('iframe')
        iframe.style.display = 'none'
        iframe.style.position = 'absolute'
        iframe.style.width = '0'
        iframe.style.height = '0'

        const cleanup = () => {
          clearTimeout(timeoutId)
          if (iframe.parentNode) {
            iframe.parentNode.removeChild(iframe)
          }
        }

        const timeoutId = window.setTimeout(() => {
          cleanup()
          reject(new Error('Logout iframe timed out'))
        }, 5000)

        iframe.onload = () => {
          cleanup()
          resolve()
        }

        iframe.onerror = () => {
          cleanup()
          reject(new Error('Logout iframe failed'))
        }

        iframe.src = logoutPath
        document.body.appendChild(iframe)
      })
    } catch {
      window.location.href = logoutPath
    }
  }
}
